import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Calendar, Users } from "lucide-react";
import { api } from "../lib/api";
import { usePageDescription } from "../lib/usePageDescription";
import PageHero from "../components/PageHero";

const Team = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const pd = usePageDescription("team", {
    title: "Wer schreibt hier?",
    intro: "Eine kleine Gruppe Habbo-Fans, die seit Jahren Geschichten, Screenshots und Erinnerungen sammelt.",
    keywords: ["Kreativ", "Leidenschaftlich", "Ehrenamtlich", "Habbo-Fans"],
  });

  useEffect(() => {
    (async () => {
      try { setMembers(await api.listTeam()); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <section className="mx-auto max-w-5xl px-4 py-10">
      <PageHero eyebrow={pd.eyebrow || "Das Team"} icon={Users} title={pd.title} keywords={pd.keywords} intro={pd.intro} />

      {loading ? (
        <div className="flex items-center justify-center py-20 text-zinc-400"><Loader2 className="h-5 w-5 animate-spin" /></div>
      ) : (
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {members.map((m) => (
            <Link
              key={m.id}
              to={`/u/${encodeURIComponent(m.habbo_name)}`}
              data-testid={`team-member-link-${m.habbo_name}`}
              className="card-hover relative overflow-hidden rounded-xl border border-white/10 bg-[#0f141b] p-5 text-center block group transition-colors hover:border-[#7c4dff]/50"
            >
              {m.background_image_url && (
                <>
                  <div
                    aria-hidden
                    className="absolute inset-0"
                    style={{ backgroundImage: `url(${m.background_image_url})`, backgroundSize: "cover", backgroundPosition: "center" }}
                  />
                  <div aria-hidden className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(15,20,27,0.45) 0%, rgba(15,20,27,0.92) 80%)" }} />
                </>
              )}
              <div className="relative">
                <div className="mx-auto flex h-28 w-28 items-center justify-center overflow-hidden">
                  <img src={m.avatar} alt={m.habbo_name} className="hb-pixel-img group-hover:scale-105 transition-transform" loading="lazy" />
                </div>
                <div className="mt-2 text-base font-semibold text-white truncate group-hover:text-[#b39bff] drop-shadow" title={m.habbo_name}>{m.habbo_name}</div>
                <div className="text-xs text-[#9d7bff]">{m.position}</div>
                <div className="mt-1 inline-flex items-center gap-1 text-xs text-zinc-400">
                  <Calendar className="h-3 w-3" /> Dabei seit {String(m.since).slice(0, 4)}
                </div>
                {m.bio && <p className="mt-2 text-xs text-zinc-300 line-clamp-3">{m.bio}</p>}
              </div>
            </Link>
          ))}
          {members.length === 0 && (
            <div className="col-span-full text-center text-sm text-zinc-500 py-10">Noch keine Teammitglieder eingetragen.</div>
          )}
        </div>
      )}
    </section>
  );
};

export default Team;
